import { ChevronIcon } from "@/components/icon";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  TableCellWithTime,
} from "@/components/TableComponents";

const vendorQuoteStrategy = [
  {
    title: <DefaultHeadColumns text="Address" />,
    dataIndex: "addressA",
    key: "locationId",
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
    render: (value: any) => (
      <DefaultTextColumn
        text={value?.locationId}
        key={value?.locationId + value.id + Math.random()}
        className="capitalize max-w-[432px] w-full truncate py-0"
        labelClassName="capitalize"
      />
    ),
  },
  {
    title: <DefaultHeadColumns text="Quote ID" />,
    dataIndex: "id",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    key: "id",
    render: (value: number) => (
      <DefaultTextColumn text={value.toString()} key={`quoteId ${value}`} />
    ),
  },

  {
    title: <DefaultHeadColumns text="Quote Request Date" />,
    dataIndex: "createdAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    key: "createdAt",
    render: (value: string, record: any) => (
      <TableCellWithTime
        value={value}
        key={record.id}
        format="DD-MM-YYYY"
        className="py-0"
      />
    ),
  },
  {
    title: <DefaultHeadColumns text="Due Date" />,
    dataIndex: "dueDate",
    key: "dueDate",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record: any) => (
      <TableCellWithTime
        value={value}
        key={record.id}
        format="DD-MM-YYYY"
        className="py-0"
      />
    ),
  },
  // {
  //   title: <DefaultHeadColumns text="RFS Date" />,
  //   dataIndex: "RFSdate",
  //   key: "RFSdate",
  //   render: (value: string, record: any) => (
  //     <TableCellWithTime
  //       value={value}
  //       key={record.id}
  //       format="DD-MM-YYYY"
  //       className="py-0"
  //     />
  //   ),
  // },

  {
    title: "",
    dataIndex: "id",
    key: "expandable",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: () => (
      <div className="-rotate-90 flex items-center justify-center ">
        <ChevronIcon />
      </div>
    ),
  },
];
export default vendorQuoteStrategy;
